// extracted by mini-css-extract-plugin
export default {"templatesSection":"TemplateSection_templatesSection__qgk8m","subTitle":"TemplateSection_subTitle__Idimx","templatesWrapper":"TemplateSection_templatesWrapper__Y1AnE"};